export type EnumValues<T> = T[keyof T];

export const LEDGER_STATUS = {
  PENDING: 'pending',
  RESERVED: 'reserved',
  COMPLETED: 'completed',
  CANCELED: 'canceled',
  REJECTED: 'rejected',
} as const;

export const TRANSACTION_TYPE = {
  DEPOSIT: 'deposit',
  WITHDRAWAL: 'withdrawal',
  TRANSFER: 'transfer',
  PLACE_BET: 'place_bet',
  WON_BET: 'won_bet',
  REFUND_BET: 'refund_bet',
  CASHOUT: 'cashout',
  BONUS: 'bonus',
  OTHER: 'other',
  WON_TO_LOST_BET: 'won_to_lost_bet',
  JACKPOT: 'jackpot',
} as const;

export const PAYMENT_METHOD = {
  BKASH: 'Bkash',
  NAGAD: 'Nagad',
  AGENT: 'Agent',
  CRYPTO: 'CRYPTO',
  USDT_BEP20: 'USDT_BEP20',
  USDT_TRC20: 'USDT_TRC20',
  LIGDICASH: 'LIGDICASH',
  ORANGE_MONEY_BURKINA: 'ORANGE',
  MOOV_AFRICA: 'MOOV',
  KAPOPAY: 'Kapopay - Credit Card',
  BANK_TRANSFER: 'Bank Transfer',
} as const;

export const FEED_SOURCE = {
  FEED_THE_BET: 'FTB',
  ODDS_MATRIX: 'ODDS_MATRIX_FEED',
} as const;

export type FeedSource = EnumValues<typeof FEED_SOURCE>;

/** The client's two products. Jackpots, maintenance and promotions are all scoped to one of them. */
export const PRODUCT = {
  SPORTSBOOK: 'sportsbook',
  CASINO: 'casino',
} as const;

export type Product = EnumValues<typeof PRODUCT>;

export const SPORT_ICON_VARIANT = {
  COLOR: 'color',
  FLAT: 'flat',
  MULTICOLOR: 'multicolor',
  NEOBET: 'neobet',
  SIMPLE: 'simple',
} as const;

export type SportIconVariant = EnumValues<typeof SPORT_ICON_VARIANT>;

export const COMPETITIONS_FLAG_VARIANT = {
  DEFAULT: 'default',
  V1: 'v1',
} as const;

export type CompetitionsFlagVariant = EnumValues<typeof COMPETITIONS_FLAG_VARIANT>;

export const LAYOUT_TYPE = {
  CASINO: 'casino',
  SPORTSBOOK: 'sportsbook',
} as const;

export type LayoutType = EnumValues<typeof LAYOUT_TYPE>;

export const NUM_OF_SELECTIONS_BONUS_ELIGIBILITY = {
  PRE_MATCH: 'PRE_MATCH',
  IN_PLAY: 'IN_PLAY',
  MIXED: 'MIXED',
} as const;

export type NumOfSelectionsBonusEligibility = EnumValues<typeof NUM_OF_SELECTIONS_BONUS_ELIGIBILITY>;

export const WALLET_TYPE = {
  MAIN: 'main',
  BONUS: 'bonus',
} as const;

export type WalletType = EnumValues<typeof WALLET_TYPE>;

export const PAYMENT_GATEWAY = {
  PAY_2_LOCAL: 'PAY_2_LOCAL',
  KAPOPAY: 'KAPOPAY',
  LIGDICASH: 'LIGDICASH',
  CRYPTO: 'CRYPTO',
} as const;

export type PaymentGateway = EnumValues<typeof PAYMENT_GATEWAY>;

export const ODDS_FORMAT = {
  DECIMAL: 'DECIMAL',
  FRACTIONAL: 'FRACTIONAL',
  AMERICAN: 'AMERICAN',
} as const;

export type OddsFormat = EnumValues<typeof ODDS_FORMAT>;

export const LOGIN_MODE = {
  EMAIL: 'email',
  USERNAME: 'username',
} as const;

export type LoginMode = EnumValues<typeof LOGIN_MODE>;

export const MARKETPLACE_AUTH_MODEL = {
  AGENT_SYSTEM: 'AGENT_SYSTEM',
  USER_REGISTRATION: 'USER_REGISTRATION',
  HYBRID: 'HYBRID',
} as const;

export type MarketplaceAuthModel = EnumValues<typeof MARKETPLACE_AUTH_MODEL>;

export const THEME_OPTION = {
  GREEN: 'green',
  DARK_BLUE: 'darkBlue',
  MODERN: 'modern',
  NEOBET: 'neobet',
  MODERN_GOLD: 'modernGold',
  MERKUR: 'merkur',
  MUTED_GREEN: 'mutedGreen',
} as const;

export type ThemeOption = EnumValues<typeof THEME_OPTION>;

export const SKIN = {
  BET365: '365',
  GOLA: 'gola',
  NEOBET: 'neobet',
} as const;

export type Skin = EnumValues<typeof SKIN>;

export const PAYMENT_TRANSACTION_TYPE = {
  DEPOSIT: 'deposit',
  WITHDRAW: 'withdraw',
} as const;

export type PaymentTransactionType = EnumValues<typeof PAYMENT_TRANSACTION_TYPE>;

export const PAYMENT_STATUS = {
  APPROVED: 'APPROVED',
  DECLINED: 'DECLINED',
  ERROR: 'ERROR',
} as const;

export type PaymentStatus = EnumValues<typeof PAYMENT_STATUS>;

export const PAYMENT_LIMIT_NAME = {
  MIN_AMOUNT_PER_TRANSACTION: 'minAmountPerTransaction',
  MAX_AMOUNT_PER_TRANSACTION: 'maxAmountPerTransaction',
  MAX_DAILY_AMOUNT: 'maxDailyAmount',
  MAX_WEEKLY_AMOUNT: 'maxWeeklyAmount',
  MAX_MONTHLY_AMOUNT: 'maxMonthlyAmount',
  MAX_DAILY_COUNT: 'maxDailyCount',
  MAX_WEEKLY_COUNT: 'maxWeeklyCount',
  MAX_MONTHLY_COUNT: 'maxMonthlyCount',
} as const;

export type PaymentLimitName = EnumValues<typeof PAYMENT_LIMIT_NAME>;

export const MARKET_DISPLAY_TYPE = {
  MULTIPLE: 'MULTIPLE',
  TEAM: 'TEAM',
  SINGLE: 'SINGLE',
  GROUPED: 'GROUPED',
} as const;

export type MarketDisplayType = EnumValues<typeof MARKET_DISPLAY_TYPE>;

export const REOFFER_DISPLAY = {
  ALL: 'ALL',
  NEW: 'NEW',
} as const;

export type ReofferDisplay = EnumValues<typeof REOFFER_DISPLAY>;

export const KYC_VERIFICATION_TRIGGER = {
  REGISTRATION: 'registration',
  FIRST_DEPOSIT: 'firstDeposit',
  FIRST_WITHDRAWAL: 'firstWithdrawal',
} as const;

export type KycVerificationTrigger = EnumValues<typeof KYC_VERIFICATION_TRIGGER>;
